import { Eye, EyeOff } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface InlineImageControlsProps {
  visible: boolean;
  onAllowImages: () => void;
}

export function InlineImageControls({ visible, onAllowImages }: InlineImageControlsProps) {
  if (!visible) {
    return null;
  }

  return (
    <div className="flex items-center justify-between rounded-lg border border-warning/40 bg-warning-surface px-4 py-2.5 text-sm">
      <div className="flex items-center gap-2">
        <EyeOff className="h-4 w-4 text-warning-ink" />
        <span className="text-warning-ink sm:inline">
          <span className="hidden sm:inline">Remote images are blocked for your privacy</span>
          <span className="inline sm:hidden">Remote images blocked</span>
        </span>
      </div>
      <Button variant="outline" size="sm" onClick={onAllowImages} className="gap-2">
        <Eye className="h-4 w-4" />
        <span className="hidden sm:inline">Display Images</span>
        <span className="inline sm:hidden">Display</span>
      </Button>
    </div>
  );
}
